import { Cpu } from "lucide-react";
import CompanyNameHeader from "../Shared/CompanyName/CompanyName";
import InsightsAi from "./Assets/InsightsAI";

// AI-Driven Innovations & Market Trends for Food Trucks
const ExpertInsights = () => (
  <>
    {/* 0. company name */}
    <CompanyNameHeader />
    <InsightsAi />

    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Cpu className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">AI-Driven Innovations & Market Trends for Food Trucks</h3>
      </div>
      <div className="prose max-w-none">
        <p className="text-gray-600">Key innovations shaping the future of the food truck industry through AI-driven technology:</p>
        <ul className="mt-4 space-y-2 text-gray-600">
          <li>
            <strong>AI-Driven Menus:</strong> Predictive analytics will optimize food offerings based on weather, local events, and regional consumer trends. AI models will suggest menu changes that align with demand patterns, reducing food waste and increasing profitability. <a href="https://www.forbes.com/sites/ai-driven-menus" className="text-blue-600">(Read More)</a>
          </li>
          <li>
            <strong>Automated Ordering & Payments:</strong> AI-integrated kiosks and voice assistants will streamline customer interactions, reducing wait times and improving user experience. Contactless payments with AI fraud detection will enhance security and convenience. <a href="https://www.businessinsider.com/ai-food-truck-automation" className="text-blue-600">(Read More)</a>
          </li>
          <li>
            <strong>Robotic Kitchens:</strong>
            <ul className="mt-2 ml-4">
              <li>Semi-autonomous cooking will cut labor costs and improve efficiency, reducing preparation time by up to 50%.</li>
              <li>AI-driven quality control will maintain consistency across menu items.</li>
              <li>Self-cleaning systems will enhance hygiene and reduce maintenance costs.</li>
            </ul>
          </li>
          <li>
            <strong>Smart Fleet Management:</strong>
            <ul className="mt-2 ml-4">
              <li>AI-powered location analytics will determine optimal times and places for food truck deployment.</li>
              <li>Real-time traffic data will help reduce downtime and maximize customer reach.</li>
              <li>Predictive maintenance will extend vehicle lifespan and minimize breakdowns.</li>
            </ul>
          </li>
          <li>
            <strong>AI-Powered Marketing:</strong>
            <ul className="mt-2 ml-4">
              <li>Hyper-personalized marketing campaigns will increase customer engagement by targeting specific demographics based on purchasing behavior.</li>
              <li>AI-driven social media management will optimize ad spend and content performance.</li>
              <li>Automated chatbots will improve customer service and loyalty programs.</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </>
);

export default ExpertInsights;
